<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tg2GU5/tc-custom/9781617750205.jpg?1705026147223" alt="This image is the cover for the book Brothers' Lot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brothers' Lot
      </h1>
      <p class="bookDescription body article font2">
        <b>A “mordantly funny” novel set in a Dublin educational institution known as the </b><b>Brothers of Godly Coercion School for Young Boys of Meager Means (<i>Publishers Weekly</i>).</b><br/><br/> Combining the spirit of Kingsley Amis's <i>Lucky Jim</i> with a bawdy evisceration of hypocrisy in old-school Catholic education, <i>The Brothers' Lot</i> is a comic satire that tells the story of the Brothers of Godly Coercion School for Young Boys of Meager Means, a dilapidated Dickensian institution run by an assemblage of eccentric, insane, and often nasty celibate Brothers. The school is in decline and the Brothers hunger for a miracle to move their founder, the Venerable Saorseach O’Rahilly, along the path to Sainthood.<br/><br/> When a possible miracle presents itself, the Brothers fervently seize on it with the help of the ethically pliant Diocesan Investigator, himself hungry for a miracle to boost his career. But the school simultaneously comes under threat from strange outside forces. The harder the Brothers try to defend the school, the worse things seem to get. It takes an outsider, Finbar Sullivan, a young student newly arrived at the school, to see that the source of the threat may in fact lie inside the school itself. As the miracle unravels, the Brothers’ efforts to preserve it unleash a disastrous chain of events.<br/><br/> Tackling a serious subject through satire, <i>The Brothers' Lot</i> explores the culture that allowed abuses within church-run institutions in Ireland to go unchecked for decades.<br/>  <br/> “Potently conveys the anarchic spirit of schoolboy warfare.”—<i>The Irish Times</i><br/><br/> “A memorable, skillfully wrought, and evocative satire of an Ireland that has collapsed under the weight of its contradictions.”—Joseph O’Connor<br/>  <br/> “Witty, brilliant, devastating.”—<i>Times Literary Supplement</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Holohan
      </h2>
      
      <p class="authorDescription body article">Kevin Holohan was born in Dublin. He is a graduate of University College Dublin and a veteran of a high school education at the hands of the Christian Brothers in Dublin. His short stories have been published in Cyphers, the Sunday Tribune (Dublin), and, most recently, in Whispers and Shouts. His poetry has been published in Studies, Casablanca, Envoi, and Poetry Ireland. He has reviewed fiction for the Irish Echo in New York. For two years he was reader for the literary department of the Abbey Theatre, Dublin. The Brothers' Lot is his first novel. He currently lives in Brooklyn with his wife and son.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic 2011
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45b87704